export const config = {
  api: process.env.NODE_ENV === "development" ? "" : "https://gpass.ghostpass.ai",
}
